import * as fromDatatype from "../datatype-library/index";

export interface bl_fi_csg_billing_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  hdr_guid: fromDatatype.GuidDataFieldInterface;
  csg_type: fromDatatype.VarcharDatatypeInterface;
  guid_gen_doc_hdr: fromDatatype.GuidDataFieldInterface;
  guid_gen_doc_line: fromDatatype.GuidDataFieldInterface;
  guid_fi_item: fromDatatype.GuidDataFieldInterface;
  guid_inv_item: fromDatatype.GuidDataFieldInterface;
  net_purchase_qty: fromDatatype.NumericDatatypeInterface;
  net_purchase_grn_qty: fromDatatype.NumericDatatypeInterface;
  closing_qty: fromDatatype.NumericDatatypeInterface;
  net_billing_qty: fromDatatype.NumericDatatypeInterface;
  amount_std: fromDatatype.MoneyDatatypeInterface;
  amount_discount: fromDatatype.MoneyDatatypeInterface;
  amount_net: fromDatatype.MoneyDatatypeInterface;
  amount_tax_gst: fromDatatype.MoneyDatatypeInterface;
  amount_tax_wht: fromDatatype.MoneyDatatypeInterface;
  amount_txn: fromDatatype.MoneyDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  opening_qty: fromDatatype.NumericDatatypeInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;

}

export class bl_fi_csg_billing_line_RowClass
  implements bl_fi_csg_billing_line_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  hdr_guid: fromDatatype.GuidDataFieldInterface;
  csg_type: fromDatatype.VarcharDatatypeInterface;
  guid_gen_doc_hdr: fromDatatype.GuidDataFieldInterface;
  guid_gen_doc_line: fromDatatype.GuidDataFieldInterface;
  guid_fi_item: fromDatatype.GuidDataFieldInterface;
  guid_inv_item: fromDatatype.GuidDataFieldInterface;
  net_purchase_qty: fromDatatype.NumericDatatypeInterface;
  net_purchase_grn_qty: fromDatatype.NumericDatatypeInterface;
  closing_qty: fromDatatype.NumericDatatypeInterface;
  net_billing_qty: fromDatatype.NumericDatatypeInterface;
  amount_std: fromDatatype.MoneyDatatypeInterface;
  amount_discount: fromDatatype.MoneyDatatypeInterface;
  amount_net: fromDatatype.MoneyDatatypeInterface;
  amount_tax_gst: fromDatatype.MoneyDatatypeInterface;
  amount_tax_wht: fromDatatype.MoneyDatatypeInterface;
  amount_txn: fromDatatype.MoneyDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  opening_qty: fromDatatype.NumericDatatypeInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
}
